import React, { useEffect, useState } from 'react';
import './App.css';
// Import gambar
import chairImage from './images/massage-chair.png';
import hotelImage from './images/hotel.webp';

function App() {
  const [isVisible, setIsVisible] = useState({});  

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(prev => ({ ...prev, [entry.target.id]: true }));
        }
      });
    }, { threshold: 0.3 });

    document.querySelectorAll('section').forEach(section => {
      observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  const locations = [
    { id: 1, name: "101 Hotel Malang", chairs: 2, lantai: "Lobby Area" }
  ];

  const faqs = [
    { q: "Cara bayarnya gimana?", a: "Mudah! Scan QRIS yang tersedia di kursi, bayar Rp20.000, langsung pijat." },
    { q: "Di mana lokasi pastinya?", a: "Berada di Lobby 101 Hotel Malang, tersedia 2 kursi pijat." },
    { q: "Jam operasionalnya kapan?", a: "Setiap hari, 24 jam non-stop! Kapan pun Anda butuh relaksasi." },
    { q: "Cocok untuk siapa saja?", a: "Untuk tamu hotel, pengunjung, atau siapa pun yang ingin rileks sejenak!" }
  ];

  return (
    <div className="App">
      <nav className="navbar">
        <div className="nav-container">
          <div className="logo">
            <span className="logo-icon">💺</span>
            <span className="logo-text">RelaxIn</span>
          </div>
          <ul className="nav-menu">
            <li><a href="#home">Beranda</a></li>
            <li><a href="#howto">Cara Pakai</a></li>
            <li><a href="#locations">Lokasi</a></li>
            <li><a href="#about">Tentang</a></li>
          </ul>
          <button className="nav-toggle">☰</button>
        </div>
      </nav>

      <section id="home" className={`hero ${isVisible.home ? 'visible' : ''}`}>
        <div className="hero-container">
          <div className="hero-content"> 
            <div className="hero-badge">✨ Hanya Rp20.000!</div>
            <h1 className="hero-title">
              Pijat Otomatis
              <br />Praktis & <span className="highlight">Terjangkau</span>
            </h1>
            <p className="hero-desc">
              Cukup scan QRIS, duduk, dan nikmati pijatan 10 menit yang menyegarkan!
            </p>
            <div className="hero-stats">
              <div className="stat">
                <h3>20K</h3>
                <p>Cukup 20 ribu</p>
              </div>
              <div className="stat">
                <h3>10 Menit</h3>
                <p>Langsung rileks</p>
              </div>
              <div className="stat">
                <h3>24 Jam</h3>
                <p>Non-stop</p>
              </div>
            </div>
          </div>
          <div className="hero-image">
            <img 
              src={chairImage} 
              alt="Kursi Pijat RelaxIn" 
              className="chair-image"
            />
            <div className="circle-bg"></div>
          </div>
        </div>
      </section>

      <section id="howto" className="how-it-works">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">✨ Gampang Banget!</span>
            <h2>Cuma <span className="highlight">4 Langkah</span> Saja</h2>
            <p>Dijamin anti ribet, langsung bisa pijatan!</p>
          </div>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-icon">🔍</div>
              <h3>Cari Kursi Kosong</h3>
              <p>Langsung menuju lobby 101 Hotel Malang</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-icon">📱</div>
              <h3>Scan QRIS</h3>
              <p>Scan pakai HP kamu</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-icon">💰</div>
              <h3>Bayar 20 Ribu</h3>
              <p>Transfer pakai QRIS, instant!</p>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <div className="step-icon">😌</div>
              <h3>Duduk & Santai</h3>
              <p>10 menit pijatan auto rileks</p>
            </div>
          </div>
        </div>
      </section>

      <section className="benefits">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">💪 Enak & Bermanfaat</span>
            <h2>Pijat 10 Menit = <span className="highlight">Tubuh Auto Segar</span></h2>
            <p>Lelah seharian? Langsung ke kursi pijat!</p>
          </div>
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon">🩸</div>
              <h3>Lancarkan Darah</h3>
              <p>Pijatan bikin aliran darahmu makin lancar</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">💪</div>
              <h3>Otot Rileks Total</h3>
              <p>Pegal-pegal langsung ilang</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">😌</div>
              <h3>Stres Hilang</h3>
              <p>Pikiran tenang, badan rileks, mood langsung happy</p>
            </div>
          </div>
        </div>
      </section>

      <section id="locations" className={`locations ${isVisible.locations ? 'visible' : ''}`}>
        <div className="container">
          <div className="section-header">
            <h2>Lokasi</h2>
          </div>
          <div className="location-with-map">
            <div className="locations-grid" style={{ margin: 0, maxWidth: '100%' }}>
              <div className="location-card">
                <div className="location-icon">🏨</div>
                <h3>101 Hotel Malang</h3>
                <p className="location-lantai">📍 Lobby Area</p>
                <p className="location-hours">⏰ 24 Jam Non-stop</p>
                <p className="location-price">💰 Rp20.000 / 10 menit</p>
              </div>
            </div>

            <div className="google-maps">
              <iframe
                title="101 Hotel Malang Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3951.141780411931!2d112.614711!3d-7.977000!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dd628310fd347d1%3A0x2d4c41e382f8aaa9!2sHotel%20101%20Malang!5e0!3m2!1sid!2sid!4v1700000000000!5m2!1sid!2sid"
                width="100%"
                height="250"
                style={{ border: 0, borderRadius: '15px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
              <a 
                href="https://www.google.com/maps/place/hotel+101+malang/@-7.977,112.617,15z" 
                target="_blank" 
                rel="noopener noreferrer"
                className="map-link-small"
              >
                🗺️ Buka di Google Maps →
              </a>
            </div>
          </div>
        </div>
      </section>

      <section id="about" className={`about ${isVisible.about ? 'visible' : ''}`}>
        <div className="container">
          <div className="about-wrapper">
            <div className="about-image">
              <div className="image-frame">
                 <div className="about-icon">💺✨</div>

              </div>
            </div>
            <div className="about-content">
              <span className="section-tag">📢 Kenapa Pilih RelaxIn?</span>
              <h2>Praktis, Murah, & <span className="highlight">Pasti Enak</span></h2>
              <p>RelaxIn adalah solusi instan buat kamu yang butuh relaksasi tanpa buang waktu. Cukup duduk manis, scan kode QR, bayar Rp20.000, dan biarkan kursi pijat otomatis kami yang bekerja.</p>
              
              <div className="vision-box">
                <h4>Visi Kami</h4>
                <p>"Menjadi layanan pijat otomatis nomor satu yang menggabungkan kenyamanan, kecepatan, dan harga bersahabat."</p>
              </div>
              
              <div className="features">
                <div className="feature">
                  <span>⚡</span>
                  <div>
                    <h4>Praktis & Cepat</h4>
                    <p>Scan QRIS langsung pijat</p>
                  </div>
                </div>
                <div className="feature">
                  <span>💰</span>
                  <div>
                    <h4>Harga Murah</h4>
                    <p>Cuma 20 ribu buat 10 menit</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="faq">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">💬 Masih Ragu?</span>
            <h2>Yuk <span className="highlight">Baca FAQ</span> Dulu</h2>
            <p>Biar makin yakin cobain pijatannya!</p>
          </div>
          <div className="faq-grid">
            {faqs.map((faq, index) => (
              <div className="faq-item" key={index}>
                <h4>❓ {faq.q}</h4>
                <p>{faq.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <div className="cta-card">
            <h2>Siap <span className="highlight">Rileks</span> Sekarang?</h2>
            <p>Langsung ke 101 Hotel Malang, cari kursi pijat RelaxIn, scan QRIS, dan rasakan pijatan 10 menit yang bikin tubuh auto segar!</p>
            <button className="btn-primary" onClick={() => document.getElementById('locations').scrollIntoView({ behavior: 'smooth' })}>Lihat Lokasi →</button>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="footer-bottom">
            <p> @2026 Relaxin</p>
          </div>
      </footer>
    </div>
  );
}

export default App;